/* eslint-disable class-methods-use-this */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-trailing-spaces */
import React from 'react';
import { connect } from 'react-redux';
import {
  COOCKIE_TITLE,
  COOCKIE_DESC,
  ACCEPT_COOCKIE,
  DECLINE,
} from '../../Utils/Constants/GlobalConstants';
import './css/CoockieModal.css';

const mapStateToProps = (state) => ({ ...state });

const GOOGLE_TAG_MANAGER_ID = 'GTM-TSB9H4B4';
const META_PIXEL_ID = '8647805661976793';

const GOOGLE_ANALYTICS_ID = 'G-9VDPZVYMB0';
const GOOGLE_SITE_VERIFICATION = 'KcgPC7HINKlvfd_LuqNE9isxCoT8Yl4b-hatkML4Arg';

const YANDEX_METRIKA_ID = '97166804';
const YANDEX_VERIFICATION = '8a95198d7b056f78';

class CoockieModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  componentDidMount() {
    const cookie = window.localStorage.getItem('cookie');

    if (cookie === null) {
      this.setState({ showModal: true });
      this.loadAll();
    } else if (cookie === 'true') {
      this.loadAll();
    }
  }

  loadAll = () => {
    this.loadGoogleTagManager();
    this.loadMetaPixel();
    this.loadGoogleAnalytics();
    this.loadYandexMetrika();
  };

  loadGoogleTagManager = () => {
    // Add the GTM <script>
    const script = document.createElement('script');
    script.async = true;
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': 
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER_ID}');
    `;
    document.head.appendChild(script);

    // Add the GTM <noscript> fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_MANAGER_ID}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noscript);
  };

  loadMetaPixel = () => {
    // Inject the Meta Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    // Add <noscript> fallback for noscript tracking
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />
    `;
    document.body.appendChild(noscript);
  };

  loadGoogleAnalytics = () => {
    // Inject the gtag.js script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
    document.head.appendChild(script1);

    // Inject the inline Google Analytics script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GOOGLE_ANALYTICS_ID}');
    `;
    document.head.appendChild(script2);

    // Add <meta> tag for Google Site Verification
    const meta = document.createElement('meta');
    meta.name = 'google-site-verification';
    meta.content = GOOGLE_SITE_VERIFICATION;
    document.head.appendChild(meta);
  };

  loadYandexMetrika = () => {
    // Inject the Yandex Metrika script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(${YANDEX_METRIKA_ID}, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true,
          webvisor:true
      });
    `;
    document.head.appendChild(script);

    // Add the noscript fallback for Yandex Metrika
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <div><img src="https://mc.yandex.ru/watch/${YANDEX_METRIKA_ID}" style="position:absolute; left:-9999px;" alt="" /></div>
    `;
    document.body.appendChild(noscript);

    // Add <meta> tag for Yandex verification
    const meta = document.createElement('meta');
    meta.name = 'yandex-verification';
    meta.content = YANDEX_VERIFICATION;
    document.head.appendChild(meta);
  };

  accept = () => {
    window.localStorage.setItem('cookie', true);
    this.setState({ showModal: false });
    this.loadAll();
  };

  decline = () => {
    window.localStorage.clear();
    window.localStorage.setItem('cookie', false);
    window.location.reload(true);
  };

  render() {
    const { showModal } = this.state;

    return (
      <>
        {showModal && (
          <div className="modal_coockie_content">
            <div className="modal_coockie_text_w">
              <div className="modal_coockie_title">{COOCKIE_TITLE}</div>
              <div className="modal_coockie_desc">{COOCKIE_DESC}</div>
            </div>
            <div className="modal_coockie_button_w">
              <button
                type="button"
                className="modal_coockie_button modal_coockie_decline"
                onClick={this.decline}
              >
                {DECLINE}
              </button>
              <button
                type="button"
                className="modal_coockie_button modal_coockie_accept blue_button"
                onClick={this.accept}
              >
                {ACCEPT_COOCKIE}
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default connect(mapStateToProps, {})(CoockieModal);
